<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Header avec navigation -->
    <div class="bg-white shadow-sm border-b border-gray-200">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-between h-16">
          <div class="flex items-center space-x-4">
            <button
              @click="router.back()"
              class="flex items-center text-gray-600 hover:text-gray-900 transition-colors"
              type="button"
            >
              <ArrowLeftIcon class="h-5 w-5 mr-2" />
              Retour
            </button>
            <div class="h-6 w-px bg-gray-300"></div>
            <h1 class="text-xl font-semibold text-gray-900">Gestion des Traductions</h1>
          </div>
        </div>
      </div>
    </div>

    <!-- Contenu principal -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <TranslationManager />
    </div>
  </div>
</template>

<script setup lang="ts">
import TranslationManager from '@components/Admin/TranslationManager.vue'
import { ArrowLeftIcon } from 'lucide-vue-next'
import { useRouter } from 'vue-router'

const router = useRouter()
</script>
